import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { SpaceShowLink } from 'utils/link';

const PaymentRedirect = ({ outcome }) => {
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  useEffect(() => {
    if (outcome === 'success') {
      setInfo('info.billing.payment.success');
    } else {
      setError('error.billing.payment.failure');
    }
    navigate(SpaceShowLink('billing'), { replace: true });
  }, [outcome, navigate, setInfo, setError]);

  return null;
};

export default PaymentRedirect;
